<script>
    import { t } from '../i18n.js'
    import ViewCardContainer from '../components/ViewCardContainer.svelte'
    import { onMount } from 'svelte'

    onMount(() => {
		window.scrollTo(0,0)
	})

</script>

<ViewCardContainer pageTitle={$t('terms.page-title')}>
    <p class="mb-4 whitespace-pre-line">{@html $t('terms.general')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.data-material-rights')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.disclaimer')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.changing-terms')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.privacy-statement')}</p>

    <p class="mb-4 whitespace-pre-line">{@html $t('terms.other-conditions')}</p>
</ViewCardContainer>